import React from 'react';
import ReactFlow, { Background } from 'reactflow';
import 'reactflow/dist/style.css';
import CustomNode from './CustomNode.js';
import CustomEdge from './CustomEdge.js';

const nodeTypes = { custom: CustomNode };
const edgeTypes = { custom: CustomEdge };

const FlowCanvas = (props) => {
  const {
    nodes,
    edges,
    onNodesChange,
    onEdgesChange,
    onConnect,
    onDrop,
    onDragOver,
    onNodeDragStart,
    onNodeDrag,
    onNodeDragStop,
    setReactFlowInstance,
    reactFlowWrapper,
    isDragging,
    defaultViewport,
  } = props;

  const infiniteExtent = [[-Infinity, -Infinity], [Infinity, Infinity]];

  const reactFlowProps = {
    nodes,
    edges,
    onNodesChange,
    onEdgesChange,
    onConnect,
    onDrop,
    onDragOver,
    onNodeDragStart,
    onNodeDrag,
    onNodeDragStop,
    nodeTypes,
    edgeTypes,
    onInit: setReactFlowInstance,
    nodesDraggable: true,
    nodesConnectable: true,
    elementsSelectable: true,
    preventScrolling: isDragging,
    translateExtent: infiniteExtent,
    nodeExtent: infiniteExtent,
    panOnDrag: true,
    deleteKeyCode: 'Delete',
    minZoom: 0.5,
    maxZoom: 2.0,
    autoPanOnNodeDrag: false
  };

  if (defaultViewport) {
    reactFlowProps.defaultViewport = defaultViewport;
  }

  return (
    <div style={{ width: '100%', height: 'calc(100vh - 60px)', position: 'absolute' }} ref={reactFlowWrapper}>
      <ReactFlow {...reactFlowProps}>
        <Background variant="lines" color="#e2e2e2" gap={20} size={1} />
      </ReactFlow>
    </div>
  );
};

export default FlowCanvas;
